import React from 'react';
import {observer} from 'mobx-react';

import {MOBILE_MAX_SCREEN_SIZE} from 'base/search.js';
import autobind from 'common/decorators/autobind.js';
import HospitalCard from 'directory/components/HospitalCard.js';
import NoResultsNotice from 'directory/components/NoResultsNotice.js';
import {HospitalDirectoryStoreContext} from 'core/stores/RootStore.js';

export default
@observer
class HospitalSearchResult extends React.Component {
    static contextType = HospitalDirectoryStoreContext;

    isMobile() {
        return window.matchMedia(`(max-width: ${MOBILE_MAX_SCREEN_SIZE})`)
            .matches;
    }

    renderResults() {
        const {
            hasHospitalResultLoaded,
            hospitalResult: {results},
        } = this.context;
        if (hasHospitalResultLoaded) {
            return results?.map((hs, i) => (
                <React.Fragment key={hs.id}>
                    <HospitalCard {...hs} />
                    {i === results.length - 15 && (
                        <li ref={this.loadMoreTargetRef}></li>
                    )}
                </React.Fragment>
            ));
        }
    }

    render() {
        const {hospitalResult, searchResultsError} = this.context;
        const props = {element: 'search-results'};
        if (this.isMobile()) {
            props.numCells = 1;
        }

        if (hospitalResult.results?.length === 0) {
            return (
                <NoResultsNotice>
                    <p>
                        No results fit your search criteria. Please update your
                        search or filter options and try again.
                    </p>
                </NoResultsNotice>
            );
        }

        if (searchResultsError) {
            return (
                <NoResultsNotice>
                    <p>
                        An error has occurred while loading this content Please
                        try again.
                    </p>
                </NoResultsNotice>
            );
        }

        return (
            <section>
                <ul>{this.renderResults()}</ul>
            </section>
        );
    }
}
